import { AppRouter } from "@/router";
import { useVersionCheck } from "@/hooks/useVersionCheck";
import { useGetUserInfo } from "./hooks/api/useGetUserInfo";
import { NoAuthSubscriber } from "@/components/NoAuthSubscriber";

export default function App() {
  useVersionCheck();
  const {} = useGetUserInfo();
  return (
    <>
      <NoAuthSubscriber />
      <AppRouter />
    </>
  );
}
